import { ModalProps } from 'almanac-ui/Modal/Types'
import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './ConfirmModal.module.scss'
import { Button } from 'blaze-ui/Button'

interface Props {
  onConfirmSecondary?: () => void
  onConfirm: () => void
  onCancel?: () => void
  title: string
  cancelText: string
  confirmText: string
  confirmTextSecondary?: string
  prompt: string
  size?: ModalProps['size']
}

export const ConfirmModal = ({
  onConfirm,
  onCancel,
  title,
  cancelText,
  confirmText,
  confirmTextSecondary,
  onConfirmSecondary,
  prompt,
  size,
}: Props) => {
  const { closeModal } = useModals()

  const handleCancel = () => {
    closeModal()
    if (onCancel) onCancel()
  }

  const handleConfirm = () => {
    closeModal()
    onConfirm()
  }

  const handleConfirmSecondary = () => {
    closeModal()
    onConfirmSecondary?.()
  }

  return (
    <Modal.Root bodyClassName={Styles.body} size={size}>
      <Modal.Header title={title} isConfirmation subHeader={prompt} />
      <Modal.Footer isConfirmation>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="secondary" onPress={handleCancel}>
            {cancelText}
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div className={Styles.buttonsContainer}>
            {confirmTextSecondary && onConfirmSecondary && (
              <Button size="lg" variant="tertiary" onPress={handleConfirmSecondary}>
                {confirmTextSecondary}
              </Button>
            )}
            <Button size="lg" variant="primary" onPress={handleConfirm}>
              {confirmText}
            </Button>
          </div>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
